export const PERMISSIONS = {
    inboundList: 'Xem danh sách hóa đơn nhập',
    inboundDetail: 'Xem chi tiết hóa đơn nhập',
    inboundPay: 'Trả nợ hóa đơn nhập',
    inboundLock: 'Khóa hóa đơn nhập',
    inboundCreate: 'Thêm hóa đơn nhập',
    inboundUpdate: 'Cập nhật hóa đơn nhập',
    inboundDelete: 'Xóa hóa đơn nhập',
    outboundList: 'Xem danh sách hóa đơn xuất',
    outboundDetail: 'Xem chi tiết hóa đơn xuất',
    outboundCreate: 'Thêm hóa đơn xuất',
    outboundUpdate: 'Cập nhật hóa đơn xuất'
};
export function roundMoney(value) {
    return Math.round(Number.isFinite(value) ? value : 0);
}
export function isInvoicePaidInFull(total, paid = 0, paidDebt = 0) {
    return total >= 0 && paid + paidDebt >= total;
}
export function calculateInbound(lines, paid = 0, paidDebt = 0) {
    const calculated = lines.map((line) => {
        const quantity = Math.max(0, line.quantity);
        const price = line.isGift ? 0 : Math.max(0, line.price);
        const discountPercent = Math.min(100, Math.max(0, line.discountPercent ?? 0));
        const gross = quantity * price;
        const discountAmount = roundMoney((gross * discountPercent) / 100);
        return {
            quantity,
            price,
            discountPercent,
            discountAmount,
            total: roundMoney(gross - discountAmount),
            profit: 0
        };
    });
    const subtotal = calculated.reduce((sum, line) => sum + line.quantity * line.price, 0);
    const discount = calculated.reduce((sum, line) => sum + line.discountAmount, 0);
    const total = calculated.reduce((sum, line) => sum + line.total, 0);
    return {
        lines: calculated,
        subtotal: roundMoney(subtotal),
        discount,
        vatAmount: 0,
        total,
        profit: 0,
        remaining: roundMoney(total - paid - paidDebt)
    };
}
export function calculateOutbound(lines, vatPercent = 0, paid = 0, paidDebt = 0) {
    const calculated = lines.map((line) => {
        const quantity = Math.max(0, line.quantity);
        const price = line.isGift ? 0 : Math.max(0, line.price);
        const inPrice = Math.max(0, line.inPrice ?? 0);
        const gross = quantity * (line.isGift ? 0 : Math.max(0, line.price));
        const discountAmount = line.discountAmount === undefined
            ? roundMoney((gross * Math.min(100, Math.max(0, line.discountPercent ?? 0))) / 100)
            : roundMoney(Math.max(0, line.discountAmount));
        const discountPercent = line.discountAmount === undefined
            ? Math.min(100, Math.max(0, line.discountPercent ?? 0))
            : gross > 0 ? Math.round((discountAmount / gross) * 100) : 0;
        return {
            quantity,
            price,
            discountPercent,
            discountAmount,
            total: roundMoney(gross - discountAmount),
            profit: roundMoney((price - inPrice) * quantity - discountAmount)
        };
    });
    const subtotal = calculated.reduce((sum, line) => sum + line.quantity * line.price, 0);
    const discount = calculated.reduce((sum, line) => sum + line.discountAmount, 0);
    const beforeVat = calculated.reduce((sum, line) => sum + line.total, 0);
    const vatAmount = roundMoney((beforeVat * Math.min(100, Math.max(0, vatPercent))) / 100);
    const total = beforeVat + vatAmount;
    return {
        lines: calculated,
        subtotal: roundMoney(subtotal),
        discount,
        vatAmount,
        total,
        profit: calculated.reduce((sum, line) => sum + line.profit, 0),
        remaining: roundMoney(total - paid - paidDebt)
    };
}
